import React from 'react';
import { getMonsterImgPath } from '../utils/monster';
import MonsterImage from './MonsterImage';

import { DefenseTeam } from '../hooks/useCounter';

interface DefenseTeamListProps {
  defenseTeams: DefenseTeam[];
  monsterMapping: any;
  onSelect: (idx: number) => void;
  selectedIdx: number | null;
}

const DefenseTeamList: React.FC<DefenseTeamListProps> = ({ defenseTeams, monsterMapping, onSelect, selectedIdx }) => {
  if (!defenseTeams || defenseTeams.length === 0) {
    return null;
  }
  return (
    <div className="defense-team-list" style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      gap: 16, 
      alignItems: 'center', 
      width: '100%',
      maxHeight: '400px',
      overflowY: 'auto',
      overflowX: 'hidden',
      paddingRight: '8px',
      WebkitOverflowScrolling: 'touch',
      scrollbarWidth: 'thin',
      scrollbarColor: '#667eea rgba(255, 255, 255, 0.3)'
    }}>
      <style>
        {`
          .defense-team-list::-webkit-scrollbar {
            width: 6px;
          }
          .defense-team-list::-webkit-scrollbar-track {
            background: rgba(255, 255, 255, 0.3);
            border-radius: 3px;
          }
          .defense-team-list::-webkit-scrollbar-thumb {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-radius: 3px;
          }
          .defense-team-list::-webkit-scrollbar-thumb:hover {
            background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
          }
        `}
      </style>
      {defenseTeams.map((g, idx) => (
        <div key={idx} style={{ width: '100%' }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              background: '#f7faff',
              borderRadius: 12,
              boxShadow: selectedIdx === idx ? '0 4px 20px rgba(102, 126, 234, 0.25)' : '0 1px 4px #0001',
              padding: '14px 22px',
              minWidth: 220,
              maxWidth: 480,
              cursor: 'pointer',
              border: selectedIdx === idx
                ? '2.5px solid transparent'
                : '2px solid #e3f0ff',
              backgroundImage: selectedIdx === idx
                ? 'linear-gradient(#f7faff, #f7faff), linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                : 'none',
              backgroundOrigin: 'border-box',
              backgroundClip: selectedIdx === idx ? 'padding-box, border-box' : 'padding-box',
              transition: 'all 0.3s ease',
              marginBottom: 2,
              boxSizing: 'border-box',
              overflow: 'hidden',
              alignItems: 'flex-start',
              position: 'relative'
            }}
            onClick={() => onSelect(idx)}
          >
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', width: '100%' }}>
              {g.team.map((m, i) => {
                const { imgPath, displayName } = getMonsterImgPath(monsterMapping, m);
                return (
                  <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 54 }}>
                    {imgPath ? (
                      <MonsterImage imgPath={imgPath} alt={displayName} style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'contain', background: '#fff', border: '1.5px solid #e3f0ff', marginBottom: 2 }} />
                    ) : (
                      <div style={{ width: 40, height: 40, borderRadius: 9, background: '#eee', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bbb', fontSize: 22, marginBottom: 2 }}>?</div>
                    )}
                    <div style={{ fontSize: 11, color: '#333', fontWeight: 600, textAlign: 'center', marginTop: 2, maxWidth: 60, textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{displayName}</div>
                  </div>
                );
              })}
              <div style={{ marginLeft: 'auto', fontWeight: 700, fontSize: 16, color: '#1976d2', minWidth: 60, textAlign: 'center' }}>
                <div style={{ fontWeight: 800, color: '#d32f2f', fontSize: 12, marginBottom: 6, letterSpacing: -1, lineHeight: 1.2 }}>설탕</div>
                {typeof g.counter_count === 'number' ? g.counter_count : 0}개
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DefenseTeamList; 